export const runtimeMappingsProjects = {
  currentStage: {
    type: 'long',
    script: {
      lang: 'painless',
      source:
        "long res = -1;if (params['_source']['status'] == 'register') {res = -1;} else if (params['_source']['stages'] != null) {long currentDate = (long)(new Date().getTime() * 1000000);def stages = params['_source']['stages'];def lastStage = stages[stages.length - 1];long endTime = Long.parseLong(lastStage.ends_at);if (currentDate > endTime) {res = -1;} else {for (int i = 0; i < params['_source']['stages'].length; i++) {long startStage = Long.parseLong(params['_source']['stages'][i]['starts_at']);long endStage = Long.parseLong(params['_source']['stages'][i]['ends_at']);if (currentDate >= startStage && currentDate <= endStage) {res = (long)(i);break;}}}}emit(res);"
    }
  },
  parsedSquare: {
    type: 'double',
    script: {
      lang: 'painless',
      source:
        "double sq = Double.parseDouble(params['_source']['square']);emit(sq);"
    }
  },
  deadline: {
    type: 'long',
    script: {
      lang: 'painless',
      source:
        "int stageId = (int)(doc['currentStage'].value);long currentDate = (long)(new Date().getTime() * 1000000);if (stageId >= 0) {emit(Long.parseLong(params['_source']['stages'][stageId]['ends_at']) - currentDate);} else {emit(0)}"
    }
  }
};

export const runtimeMappingsHistory = {
  amountAffirm: {
    type: 'long',
    script: `double amountPrice = Double.parseDouble(params['_source']['amount']);
    if (params['_source']['affirm']) {
  long amountType=(long)(amountPrice/ 1e24);
  emit(amountType)
} else emit(0);`
  },
  amountDeny: {
    type: 'long',
    script: `double amountPrice =Double.parseDouble(params['_source']['amount']);
  if(params['_source']['affirm']) {
    emit(0);
  } else{
    long amountType = (long)(amountPrice/ 1e24);
    emit(amountType);}`
  }
};
